module.exports = __webpack_public_path__ + "static/media/buildingConstruction13.8984603f.jpg";